import React, { Component, Fragment } from 'react'

import TopBar from '../TopBar/'
import BottomBar from '../BottomBar/'

class MobileHeader extends Component {

  handleSwitchBranch() {
    this.props.onSwitchBranch()
  }

  handleClickContact() {
    this.props.onClickContact()
  }

  render() {
    return (
      <Fragment>
        <TopBar 
          logo={this.props.logo} 
          onClickContact={this.handleClickContact.bind(this)}
        />
        <BottomBar
          branchName={this.props.branchName}
          onSwitchBranch={this.handleSwitchBranch.bind(this)}
          handleLogout={this.props.handleLogout}
          permissions={this.props.permissions}
          nrOfOrders={this.props.nrOfOrders}
          gender={this.props.gender}
        />
      </Fragment>
    )
  }
}

export default MobileHeader



// WEBPACK FOOTER //
// ./src/components/MobileHeader/MobileHeader/index.js